import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import React from 'react';
import { Switch } from 'react-router';
import { connect } from 'react-redux';
import { Exceptions } from './exception';
import {ReprocessLogs} from './reprocess'
import { RouteWithPermissions } from 'containers/route-with-permissions';
import { DownloadRouting } from './charge-download/DownloadRouting';
import { DownloadRoutingChargeImport } from './charge-import/DownloadRouting';
import { getEnvironmentBaseUrl } from 'utilities/route-utils';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { isFeatureEnabled } from 'utilities/featureToggles';
import { IStore } from 'reducers/index';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { LoadingAnimation } from 'components/loading';

interface ExternalRedirectProps {
    to: string;
}

const EXCEPTION_APP_PATH = '/scp/cshub/finops-exception-management/exception';
const LOGS_APP_PATH = '/scp/cshub/logs/invoice';

const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ to }) => {
    React.useEffect(() => {
        const baseUrl = getEnvironmentBaseUrl();
        const redirectUrl = `${baseUrl}${to}`;
        window.location.assign(redirectUrl);
    }, [to]);
    return null;
};

interface IMapStateToProps {
    featureToggles: IFeatureToggleModel[];
    isFeatureDataReady: boolean;
}

interface ICshubRedirectProps extends IMapStateToProps {
    to: string;
    reactComponent: React.ComponentType<any>;
}

export const _CshubRedirect = ({ to, reactComponent: ReactComponent, featureToggles, isFeatureDataReady }: ICshubRedirectProps) => {
    if (!isFeatureDataReady) {
        return <LoadingAnimation />;
    }
    if (isFeatureEnabled(featureToggles, [FEATURE_TOGGLES.FINOPS_EXCEPTION_MANAGEMENT_UI])) {
        return <ExternalRedirect to={to} />;
    }
    return <ReactComponent />;
};

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    featureToggles: state.featureToggle.featureToggles,
    isFeatureDataReady: state.featureToggle.isFeatureDataReady
});

const CshubRedirect = connect(mapStateToProps)(_CshubRedirect);

export const ExceptionManagementRouting = () => {
    return(
        <Switch>
            <RouteWithPermissions
                path="/exception-management/exceptions/open-exceptions"
                render={() => (
                    <CshubRedirect to={`${EXCEPTION_APP_PATH}/exception-management`} reactComponent={Exceptions} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/exception-management/exceptions/closed-exceptions"
                render={() => (
                    <CshubRedirect to={`${EXCEPTION_APP_PATH}/exception-management`} reactComponent={Exceptions} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/exception-management/exceptions"
                render={() => (
                    <CshubRedirect to={`${EXCEPTION_APP_PATH}/exception-management`} reactComponent={Exceptions} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/exception-management/reprocess"
                render={() => (
                    <CshubRedirect to={`${LOGS_APP_PATH}/reprocess-log`} reactComponent={ReprocessLogs} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/exception-management/reprocess/open-logs"
                render={() => (
                    <CshubRedirect to={`${LOGS_APP_PATH}/reprocess-log`} reactComponent={ReprocessLogs} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/exception-management/reprocess/closed-logs"
                render={() => (
                    <CshubRedirect to={`${LOGS_APP_PATH}/reprocess-log`} reactComponent={ReprocessLogs} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
            />
            <RouteWithPermissions
                path="/exception-management/charge-import"
                render={() => (
                    <CshubRedirect to={`${EXCEPTION_APP_PATH}/charge-upload-log`} reactComponent={DownloadRoutingChargeImport} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_IMPORT, FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_EXPORT]}
            />
            <RouteWithPermissions
                path="/exception-management/charge-download"
                render={() => (
                    <CshubRedirect to={`${EXCEPTION_APP_PATH}/charge-download-log`} reactComponent={DownloadRouting} />
                )}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES, FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES_EXPORTJOB]}
            />
        </Switch>
    );
};
